



// 



import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoginComponent } from "./components/login/login.component";
import { HomeComponent } from "./components/home/home.component";
import { ProductsComponent } from "./components/products/products.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { QuoteSettingsComponent } from "./components/quote-settings/quote-settings.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { GroupsComponent } from './components/groups/groups.component';
import { BenefitsComponent } from './components/benefits/benefits.component';
import { VendorsComponent } from './components/vendors/vendors.component';
import { ProductDetailComponent } from './components/products/product-detail/product-detail.component';
import { MembersComponent } from './components/members/members.component';
import { HistoryComponent } from './components/history/history.component';
import { QuoteHomeComponent } from './components/quote-home/quote-home.component';
import { MemberDetailDialogComponent } from './components/members/member-detail-dialog/member-detail-dialog.component';
import { NewMemberComponent } from './components/members/new-member/new-member.component';
import { CasesComponent } from './components/cases-management/cases-management.component';
import { CaseDetailComponent } from './components/cases-management/case-detail/case-detail.component';
import { NewCaseComponent } from './components/cases-management/new-case/new-case.component';
import { CasesManagementDashboardComponent } from './components/cases-management-dashboard/cases-management-dashboard.component';
import { FileDetailComponent } from './components/file-detail/file-detail.component';
import { ErrorDetailComponent } from './components/error-detail/error-detail.component';
import { MemberLogsComponent } from './components/member-logs/member-logs.component';



@NgModule({
    imports: [
        RouterModule.forRoot([
            { path: "", component: HomeComponent, canActivate: [AuthGuard], data: { title: "Home" } },
            { path: "login", component: LoginComponent, data: { title: "Login" } },
            { path: "groups", component: GroupsComponent, canActivate: [AuthGuard], data: { title: "Groups", role: "groups.read" } },
            { path: "groups/:groupId", component: ProductsComponent, canActivate: [AuthGuard], data: { title: "Products" } },
            { path: "products", component: ProductsComponent, canActivate: [AuthGuard], data: { title: "Products", role: "plans.read" } },
            { path: "products/:productId", component: ProductDetailComponent, canActivate: [AuthGuard], data: { title: "Product Detail" } },
            { path: "benefits", component: BenefitsComponent, canActivate: [AuthGuard], data: { title: "BenefitsComponent", role: "benefits.read" } },
            { path: "vendors", component: VendorsComponent, canActivate: [AuthGuard], data: { title: "VendorsComponent", role: "vendors.read" } },
            { path: "vendors/:vendorId", component: BenefitsComponent, canActivate: [AuthGuard], data: { title: "BenefitsComponent" } },
            { path: "members", component: MembersComponent, canActivate: [AuthGuard], data: { title: "MembersComponent" } },
            { path: "members/:memberId", component: MemberDetailDialogComponent, canActivate: [AuthGuard], data: { title: "MembersComponent" } },
            { path: "member-logs", component: MemberLogsComponent, canActivate: [AuthGuard], data: { title: "MemberLogsComponent" } },
            { path: "member-logs/:memberId", component: MemberLogsComponent, canActivate: [AuthGuard], data: { title: "MemberLogsComponent" } },

            { path: "case-management", component: CasesComponent, canActivate: [AuthGuard], data: { title: "CasesComponent" } },
            { path: "case-management-dashboard", component: CasesManagementDashboardComponent, canActivate: [AuthGuard], data: { title: "Case sManagement Dashboard" } },
            { path: "case-management/:caseNum", component: CaseDetailComponent, canActivate: [AuthGuard], data: { title: "Case Detail" } },
            { path: "new-case", component: NewCaseComponent, canActivate: [AuthGuard], data: { title: "New Case" } },
            { path: "new-member", component: NewMemberComponent, canActivate: [AuthGuard], data: { title: "New Member" } },
            { path: "history", component: HistoryComponent, canActivate: [AuthGuard], data: { title: "HistoryComponent" } },
            { path: "settings", component: SettingsComponent, canActivate: [AuthGuard], data: { title: "Settings" } },
            { path: "quote-home", component: QuoteHomeComponent, canActivate: [AuthGuard], data: { title: "Quote Home" } },
            { path: "quote-settings", component: QuoteSettingsComponent, canActivate: [AuthGuard], data: { title: "Quote Settings" } },
            { path: "home", redirectTo: "/", pathMatch: "full" },
            { path: "file-detail", component: FileDetailComponent, canActivate: [AuthGuard], data: { title: "File Detail" } },
            { path: "error-detail", component: ErrorDetailComponent, canActivate: [AuthGuard], data: { title: "Error Detail" } },
            { path: "**", component: NotFoundComponent, data: { title: "Page Not Found" } },
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        AuthService, AuthGuard
    ]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/app-routing.module.ts